"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NoSamplesFoundSubheading_1 = require("./NoSamplesFoundSubheading");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return NoSamplesFoundSubheading_1.default; } });
